import script from "./HeaderMyPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./HeaderMyPage.vue?vue&type=script&lang=ts&setup=true"

import "./HeaderMyPage.vue?vue&type=style&index=0&id=65138cf7&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/jobs/MYNAVI_MP_VIEW_G_PROD/workspace/view/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65138cf7"]])

export default __exports__